function soeraLegacyBagFinish(value) {
  return ['suede', 'suède', 'wildleder', 'velours', 'daim'].includes(value.toLowerCase());
}

function soeraBagFinishUrl(base, tag, enabled) {
  const url = new URL(window.location.href);
  const basePath = new URL(base, url).pathname.replace(/\/$/, '');
  const existingTags = url.pathname.slice(basePath.length).replace(/^\//, '').split('+').filter(Boolean);
  const tags = existingTags.filter(value => value !== tag);
  if (enabled) tags.push(tag);
  url.pathname = basePath + (tags.length ? '/' + tags.join('+') : '');
  url.searchParams.delete('page');
  const shades = url.searchParams.getAll('filter.v.option.color');
  if (shades.some(soeraLegacyBagFinish)) {
    url.searchParams.delete('filter.v.option.color');
    shades.filter(value => !soeraLegacyBagFinish(value)).forEach(value => url.searchParams.append('filter.v.option.color', value));
  }
  return url.pathname + url.search;
}

function soeraLoadBagFinish(control, url) {
  const container = control.closest('filter-container');
  if (container && typeof container.ajaxLoadUrl === 'function') container.ajaxLoadUrl(url);
  else window.location.assign(url);
}

document.addEventListener('change', (event) => {
  const input = event.target;
  if (input instanceof HTMLInputElement && input.hasAttribute('data-soera-bag-material-tag')) {
    event.stopImmediatePropagation();
    soeraLoadBagFinish(input, soeraBagFinishUrl(input.dataset.soeraBagMaterialBase, input.dataset.soeraBagMaterialTag, input.checked));
    return;
  }
  if (input instanceof HTMLInputElement && input.hasAttribute('data-soera-bag-color-group')) {
    const group = input.dataset.soeraBagColorGroup;
    input.closest('form').querySelectorAll('[data-soera-bag-shade-family]').forEach((shade) => {
      if (shade.dataset.soeraBagShadeFamily === group) shade.checked = input.checked;
    });
  }
  if (input instanceof HTMLInputElement && input.hasAttribute('data-soera-size-color-group')) {
    const group = input.dataset.soeraSizeColorGroup;
    input.closest('form').querySelectorAll('[data-soera-size-shade-family]').forEach((shade) => {
      if (shade.dataset.soeraSizeShadeFamily === group) shade.checked = input.checked;
    });
  }
  if (input instanceof HTMLInputElement && input.hasAttribute('data-soera-type-color-group')) {
    const group = input.dataset.soeraTypeColorGroup;
    input.closest('form').querySelectorAll('[data-soera-type-shade-family]').forEach((shade) => {
      if (shade.dataset.soeraTypeShadeFamily === group) shade.checked = input.checked;
    });
  }
}, true);

// Shopify keeps raw shade URLs working after native grouping, but omits those
// shades from Liquid active_values. Recover them without broadening the query.
(() => {
  const shadeFamilies = {"black":"black","black clear":"black","black floral":"black","black frame dark lenses":"black","black leather":"black","black low":"black","black no. 1":"black","black no. 2":"black","black polka dot":"black","black set":"black","black suede":"black","floral black":"black","glazed black":"black","long black":"black","schwarz":"black","short black":"black","suede black":"black","cream":"white","creamy white":"white","creamy-white":"white","creme":"white","ivory":"white","long white":"white","off-white":"white","offwhite":"white","pearl white":"white","set white":"white","short white":"white","weiß":"white","white":"white","white 3 piece set":"white","white lace":"white","white leopard":"white","white low":"white","white plain":"white","white polka dot":"white","white polka dots":"white","white set":"white","white set (top+skirt)":"white","aqua":"blue","aqua blue":"blue","azure":"blue","baby blue":"blue","blau":"blue","blue":"blue","blue set":"blue","blue set (top+short)":"blue","blue stripe":"blue","blue stripes":"blue","dark blue":"blue","dark blue plain":"blue","dark blue stripe":"blue","dark teal":"blue","dark wash":"blue","darkblue":"blue","deep blue":"blue","denim blue":"blue","lake blue":"blue","light  blue":"blue","light blue":"blue","light turquoise":"blue","light wash":"blue","navy":"blue","navy blue":"blue","plain blue":"blue","royal blue":"blue","set plaid blue":"blue","sky blue":"blue","teal":"blue","teal blue":"blue","turquoise":"blue","water blue":"blue","apricot":"beige","aprikose":"beige","beige":"beige","beige leather":"beige","beige low":"beige","beige set":"beige","beige skirt":"beige","beige suede":"beige","beige top":"beige","beige-skirt":"beige","camel":"beige","ginger":"beige","khaki":"beige","light beige":"beige","light khaki":"beige","long taupe":"beige","milktea":"beige","nude":"beige","oatmilk":"beige","sand":"beige","short taupe":"beige","tan":"beige","taupe":"beige","taupe suede":"beige","auburn":"brown","brown":"brown","brow":"brown","brown dress":"brown","brown polka dot":"brown","brown suede":"brown","choco":"brown","choco brown":"brown","chocolate":"brown","chocolate brown":"brown","coffe":"brown","coffee":"brown","dark brown":"brown","dark brown suede":"brown","deep brown":"brown","deep coffee":"brown","grayish coffee":"brown","latte":"brown","light brown":"brown","light coffee":"brown","long coffee":"brown","mocha":"brown","mustard brown":"brown","rusty brown":"brown","short coffee":"brown","suede brown":"brown","ash gray":"gray","charcoal":"gray","dark gray":"gray","dark grey":"gray","gray":"gray","gray set":"gray","grey":"gray","grey plaid":"gray","light gray":"gray","light grey":"gray","long grey":"gray","short grey":"gray","stone gray":"gray","taupe-grey":"gray","army green":"green","armygreen":"green","avocado green":"green","dark green":"green","darkgreen":"green","floral green":"green","green":"green","green plaid":"green","green set (top+short)":"green","light green":"green","mint":"green","mint green":"green","olive":"green","olive green":"green","olivegreen":"green","sage":"green","saige green":"green","tortoise / green":"green","yellow green":"green","baby pink":"pink","blush":"pink","blush pink":"pink","dusty pink":"pink","dusty rose":"pink","floral pink":"pink","fuchsia":"pink","fuschia":"pink","hot pink":"pink","leopard pink":"pink","light pink":"pink","magenta":"pink","old rose":"pink","peach":"pink","pink":"pink","pink heart":"pink","pink polka dot":"pink","pink set":"pink","pink skirt":"pink","pink striped":"pink","pink stripes":"pink","pink top":"pink","plain pink":"pink","rosa":"pink","rose":"pink","rose pink":"pink","soft peach":"pink","dark purple":"purple","lavender":"purple","lilac":"purple","plum":"purple","purple":"purple","purple flower":"purple","violet":"purple","burgundy":"red","burgundy leather":"red","claret":"red","dark red":"red","maroon":"red","red":"red","red flower":"red","red stripes":"red","rose red":"red","rot":"red","scarlet":"red","short burgundy":"red","wine":"red","wine polka dot":"red","wine red":"red","winered":"red","orange":"orange","orange set":"orange","orange set (top+short)":"orange","rust":"orange","tortoise / orange":"orange","bright yellow":"yellow","butter yellow":"yellow","ginger yellow":"yellow","light yellow":"yellow","lime yellow":"yellow","mustard":"yellow","mustard yellow":"yellow","pale yellow":"yellow","yellow":"yellow","yellow set":"yellow","champagne gold":"gold","gold":"gold","gold frame brown lenses":"gold","gold frame dark lenses":"gold","gold frame green lenses":"gold","rose gold":"gold","rosegold":"gold","silber":"silver","silver":"silver","silver frame dark lenses":"silver","sliver":"silver","2 tone":"multicolor","auburn white":"multicolor","black / orange":"multicolor","black & white":"multicolor","black blue":"multicolor","black orange":"multicolor","black white":"multicolor","black yellow":"multicolor","black/white":"multicolor","blue gray":"multicolor","blue/black":"multicolor","brown black":"multicolor","burgundy black":"multicolor","floral":"multicolor","garden print":"multicolor","gold / black":"multicolor","gold / brown":"multicolor","gray blue":"multicolor","green blue":"multicolor","leopard":"multicolor","leopard clear":"multicolor","leopard tea":"multicolor","multi":"multicolor","multi-color":"multicolor","multicolor":"multicolor","multicolored":"multicolor","navy white":"multicolor","orange pink":"multicolor","orange/yellow":"multicolor","pink/black":"multicolor","pink/white":"multicolor","plaid":"multicolor","polka dot":"multicolor","red/white":"multicolor","striped":"multicolor","stripes":"multicolor","taupe brown":"multicolor","tortoise":"multicolor","white black":"multicolor","white red":"multicolor","white/black":"multicolor","yellow beige":"multicolor","yellow/black":"multicolor","yellow/blue":"multicolor"};
  const hydratedForms = new WeakSet();
  const colorParam = 'filter.v.option.color';
  function hydrate() {
    const filters = document.querySelector('.filters');
    const form = filters && filters.querySelector('form');
    const colors = form && form.querySelector('.soera-bag-color-filter');
    if (!colors || hydratedForms.has(form)) return;
    hydratedForms.add(form);
    const current = new URL(window.location.href);
    const shades = current.searchParams.getAll(colorParam);
    const material = form.querySelector('[data-soera-bag-material-tag]');
    if (material && shades.some(soeraLegacyBagFinish)) {
      soeraLoadBagFinish(material, soeraBagFinishUrl(material.dataset.soeraBagMaterialBase, material.dataset.soeraBagMaterialTag, true));
      return;
    }
    const nativeInputs = [...form.querySelectorAll('[data-soera-bag-shade-family]')];
    const groupIds = new Map(nativeInputs.map(input => [input.value, input.dataset.soeraBagShadeFamily]));
    const nativeFamilies = new Set(nativeInputs.filter(input => input.checked).map(input => input.dataset.soeraBagShadeFamily));
    const legacyFamilies = new Set();
    shades.forEach(value => {
      const family = shadeFamilies[value.toLowerCase()];
      if (!family || groupIds.has(value)) return;
      legacyFamilies.add(family);
      const existing = [...form.querySelectorAll('input')].find(input => input.name === colorParam && input.value === value);
      const input = existing || document.createElement('input');
      input.type = 'checkbox';
      input.hidden = true;
      input.name = colorParam;
      input.value = value;
      input.checked = true;
      input.dataset.soeraBagShadeFamily = family;
      if (!existing) colors.appendChild(input);
      const group = colors.querySelector('[data-soera-bag-color-group="' + family + '"]');
      if (group) {
        group.checked = true;
        group.disabled = false;
        group.closest('label').classList.add('filter-group__item--active');
        group.closest('label').classList.remove('filter-group__item--disabled');
      }
    });
    if (!legacyFamilies.size) return;
    const heading = colors.querySelector('.filter-group__heading');
    const items = colors.querySelector('.filter-group__items');
    if (heading) heading.classList.remove('toggle-target-toggler--is-hidden');
    if (items) items.classList.remove('toggle-target--hidden');
    let applied = filters.querySelector('.filter-group--applied');
    if (!applied) {
      applied = document.createElement('div');
      applied.className = 'filter-group filter-group--applied';
      const title = document.createElement('div');
      title.className = 'filter-group__heading';
      const titleText = document.createElement('div');
      titleText.className = 'filter-group__heading__text';
      titleText.textContent = colors.dataset.soeraAppliedLabel;
      title.appendChild(titleText);
      applied.appendChild(title);
      const list = document.createElement('div');
      list.className = 'filter-group__items';
      applied.appendChild(list);
      const clearRow = document.createElement('div');
      clearRow.className = 'filter-group__clear-row';
      const clear = document.createElement('a');
      clear.className = 'filter-group__clear-link';
      const cleared = new URL(current);
      [...cleared.searchParams.keys()].filter(key => key.startsWith('filter.') || key === 'page').forEach(key => cleared.searchParams.delete(key));
      clear.href = cleared.pathname + cleared.search;
      clear.textContent = colors.dataset.soeraClearLabel;
      clearRow.appendChild(clear);
      list.appendChild(clearRow);
      form.before(applied);
    }
    legacyFamilies.forEach(family => {
      if (applied.querySelector('[data-soera-bag-color-remove="' + family + '"]')) return;
      const group = colors.querySelector('[data-soera-bag-color-group="' + family + '"]');
      if (!group) return;
      const link = document.createElement('a');
      link.className = 'filter-group__applied-item';
      link.dataset.soeraBagColorRemove = family;
      const label = document.createElement('span');
      label.className = 'filter-group__applied-item__text';
      label.textContent = group.closest('label').querySelector('.filter-group__item__text').textContent.trim();
      link.appendChild(label);
      const icon = document.createElement('span');
      icon.className = 'filter-group__applied-item__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '×';
      link.appendChild(icon);
      const list = applied.querySelector('.filter-group__items');
      list.insertBefore(link, list.querySelector('.filter-group__clear-row'));
    });
    applied.querySelectorAll('[data-soera-bag-color-remove]').forEach(link => {
      const family = link.dataset.soeraBagColorRemove;
      const removal = new URL(current);
      removal.searchParams.delete(colorParam);
      removal.searchParams.delete('page');
      shades.forEach(value => {
        if ((groupIds.get(value) || shadeFamilies[value.toLowerCase()]) !== family) removal.searchParams.append(colorParam, value);
      });
      link.href = removal.pathname + removal.search;
    });
    const extraCount = [...legacyFamilies].filter(family => !nativeFamilies.has(family)).length;
    const toggle = document.querySelector('[data-toggle-filters]');
    if (extraCount && toggle) {
      let count = toggle.querySelector('.toggle-btn__count');
      const nativeCount = count ? Number(count.textContent.replace(/[^0-9]/g, '')) : 0;
      if (!count) {
        count = document.createElement('span');
        count.className = 'toggle-btn__count';
        toggle.appendChild(count);
      }
      count.textContent = '(' + (nativeCount + extraCount) + ')';
    }
  }
  function start() {
    hydrate();
    const filters = document.querySelector('.filters');
    if (filters) new MutationObserver(hydrate).observe(filters, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-soera-bag-material-remove]');
  if (!link) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const url = soeraBagFinishUrl(link.dataset.soeraBagMaterialBase, link.dataset.soeraBagMaterialRemove, false);
  link.href = url;
  soeraLoadBagFinish(link, url);
}, true);
